import cl from '@/utils/console/cl'
import urls from '@/utils/urls/urls'
import React from 'react'
import AnimationWrapper from '../AnimationWrapper/AnimationWrapper'

const WhyChooseUs = async () => {
    const res = await fetch(urls?.why_choose_us, {
        cache: 'no-store'
    })
    const data = await res.json()
    const why_choose_us = Array.isArray(data?.data) ? data?.data : [];
    // cl("why_choose_us", why_choose_us)

    const aboutRes = await fetch(urls?.about, {
        cache: "no-store"
    })
    // console.log("aboutRes", aboutRes);
    if (!aboutRes.ok) {
        // console.log("aboutRes has an Error", aboutRes)
    }
    const aboutData = await aboutRes.json()
    // console.log("aboutData", aboutData)
    const about = aboutData?.data[0]
    // console.log("about", about);

    return (
        <>
            <div className="choose-area py-100 "
                style={{
                    background: "#f6f6f6"
                    // background: ""
                }}>
                <div className="container">
                    <div className="row pb60">
                        <div className="col-lg-6">
                            <AnimationWrapper animation="fade-left">
                                <div className="choose-content wow fadeInUp" data-wow-delay=".25s">
                                    <div className="site-heading mb-0">

                                        <span className="site-title-tagline">
                                            <i className="fas fa-solar-panel" /> Why Choose Us
                                        </span>
                                        {/* <h2 className="site-title">
                                        We deliver <span>expertise you can trust</span> our service
                                    </h2>
                                    <p>
                                        It is a long established fact that a reader will be distracted
                                        by the readable content of a page when looking at its layout.
                                    </p> */}
                                    </div>
                                    <div className="choose-content-wrap">
                                        {
                                            why_choose_us?.map((item: any) => (
                                                <div className="choose-item" key={item?.id}>
                                                    <div className="choose-item-icon">
                                                        {/* <img src="../assets/img/icon/staff.svg" alt="" /> */}
                                                        <i className={`${item.icon_class} icon-size-lg why-choose-us-icon`}></i>
                                                    </div>
                                                    <div className="choose-item-info">
                                                        <h4>{item.title}</h4>
                                                        <p>
                                                            {item.description}
                                                        </p>
                                                    </div>
                                                </div>
                                            ))
                                        }
                                        {/* <div className="choose-item">
                                        <div className="choose-item-icon">
                                            <img src="../assets/img/icon/money-2.svg" alt="" />
                                        </div>
                                        <div className="choose-item-info">
                                            <h4>Affordable Cost</h4>
                                            <p>
                                                At Tex Excellence Limited, our mission is to assist brands, designers, and manufacturers in creating cutting-edge fabric technologies that significantly enhance the final products.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="choose-item">
                                        <div className="choose-item-icon">
                                            <img src="../assets/img/icon/staff.svg" alt="" />
                                        </div>
                                        <div className="choose-item-info">
                                            <h4>Our Experience Team</h4>
                                            <p>
                                                There are many variations of passages available the
                                                majority have suffered alteration in some by injected
                                                humour.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="choose-item">
                                        <div className="choose-item-icon">
                                            <img src="../assets/img/icon/certified.svg" alt="" />
                                        </div>
                                        <div className="choose-item-info">
                                            <h4>Certified Company</h4>
                                            <p>
                                                There are many variations of passages available the
                                                majority have suffered alteration in some by injected
                                                humour.
                                            </p>
                                        </div>
                                    </div> */}
                                    </div>
                                </div>
                            </AnimationWrapper>
                        </div>
                        <div className="col-lg-6">
                            <AnimationWrapper animation="fade-right">
                                <div className="choose-img wow fadeInRight" data-wow-delay=".25s">
                                    {about?.img1 && <img className="img-2" src={urls?.image + about?.img1} alt="" />}
                                    {about?.img2 && <img className="img-1" src={urls?.image + about?.img2} alt="" />}
                                    {about?.circle_img && <img className="shape shape-img" src={urls?.image + about?.circle_img} alt="" />}
                                    {/* <img className="img-1" src="../assets/img/choose/11.jpg" alt="" />
                                <img className="img-2" src="../assets/img/choose/22.jpg" alt="" />
                                <img className="shape shape-img" src="../assets/img/shape/pailung_logo.jpg" alt="" /> */}
                                </div>
                            </AnimationWrapper>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default WhyChooseUs
